import { render, staticRenderFns } from "./ArticleContributors.vue?vue&type=template&id=aa381082&"
import script from "./ArticleContributors.vue?vue&type=script&lang=ts&"
export * from "./ArticleContributors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports